const Twitter = (props) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='#152a46'
    {...props}
    className={props?.color}
  >
    <path d='M34.141,5.859A19.269,19.269,0,0,0,20,0,19.269,19.269,0,0,0,5.859,5.859,19.269,19.269,0,0,0,0,20,19.269,19.269,0,0,0,5.859,34.141,19.269,19.269,0,0,0,20,40a19.269,19.269,0,0,0,14.141-5.859A19.269,19.269,0,0,0,40,20,19.269,19.269,0,0,0,34.141,5.859Zm-4.219,9.688a2.568,2.568,0,0,1,.078.625,14.231,14.231,0,0,1-3.828,9.648,12.973,12.973,0,0,1-10.234,4.336,13.7,13.7,0,0,1-7.5-2.187,8.3,8.3,0,0,0,1.172.078A9.734,9.734,0,0,0,15.7,25.938a5.108,5.108,0,0,1-2.891-1.016A4.743,4.743,0,0,1,11.094,22.5a5.693,5.693,0,0,0,.938.078,6.133,6.133,0,0,0,1.328-.156A5.152,5.152,0,0,1,10.508,20.7a4.663,4.663,0,0,1-1.133-3.125V17.5a4.237,4.237,0,0,0,2.266.625,4.621,4.621,0,0,1-2.266-4.063,4.779,4.779,0,0,1,.7-2.5,13.353,13.353,0,0,0,10.156,5.156,4.248,4.248,0,0,1-.156-1.172A4.935,4.935,0,0,1,25,10.625a4.619,4.619,0,0,1,3.594,1.563,9.033,9.033,0,0,0,3.125-1.172,4.653,4.653,0,0,1-2.109,2.734,9.485,9.485,0,0,0,2.813-.781A10.674,10.674,0,0,1,29.922,15.547ZM40,37.5' />
    <style jsx>
      {`
        .UA {
          fill: rgb(255, 69, 9) !important;
        }
      `}
    </style>
  </svg>
)

export default Twitter
